import Link from "next/link";

/** 워드마크. 각(角) 모양을 기울어진 사각 심볼로 표현한다. */
export function Logo({ href = "/", size = "md" }: { href?: string; size?: "md" | "lg" }) {
  const box = size === "lg" ? "size-8" : "size-7";
  const text = size === "lg" ? "text-xl" : "text-lg";
  return (
    <Link href={href} className="inline-flex items-center gap-2" aria-label="입찰각 홈">
      <svg viewBox="0 0 32 32" className={box} aria-hidden="true">
        <rect width="32" height="32" rx="9" className="fill-primary-900" />
        <path d="M9 22.5L16.5 8.5 23 22.5" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.2 17.5h8.2" stroke="white" strokeWidth="3" strokeLinecap="round" />
      </svg>
      <span className={`${text} font-bold tracking-tight text-gray-900`}>입찰각</span>
    </Link>
  );
}
